import React from "react";

export default function ContactForm() {
  return (
    <div className=" pb-[13.4rem] ">
      <div className="px-[2.5rem] block w-full mx-auto 0">
        <form className="  flex flex-col justify-center  md:gap-16 items-center">
          <div className="grid md:grid-cols-2 grid-cols-1 xl:w-4/5 md:gap-8 md:w-11/12 w-full">
            <div className="">
              <div data-aos="fade-up" data-aso-delay="100" className="relative z-0 w-full group xl:my-[5.135rem] md:my-16 my-8 flex flex-col-reverse">
                <input
                  type="text"
                  name="name"
                  id="name"
                  className="pt-[1.2rem] bg-red pb-[1.2rem] tracking-[0.02em] text-[1.3rem] font-Matter text-white outline-2 outline-transparent outline-offset-2  appearance-none outline-none block bg-transparent border-b-[max(1px,_0.0625rem)] border-solid border-[#cfa751] md:w-[90%] w-full focus:outline-none focus:ring-0 focus:border-[#cfa751] peer"
                  placeholder=""
                  required
                />
                <label
                  for="name"
                  className="peer-focus:font-semibold peer-focus:text-[1.3rem] absolute uppercase font-Matter text-[1rem] text-white tracking-[.2em] form-line-flex focus-within:[&>label]:text-[#cfa751] font-semibold duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#cfa751] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Your name
                </label>
              </div>
              <div data-aos="fade-up" data-aso-delay="300" className="relative z-0 w-full group xl:my-[5.135rem] md:my-16 my-8 flex flex-col-reverse">
                <input
                  type="text"
                  name="number"
                  id="number"
                  className="pt-[1.2rem] pb-[1.2rem] tracking-[0.02em] text-[1.3rem] font-Matter text-white outline-2 outline-transparent outline-offset-2  appearance-none outline-none block bg-transparent border-b-[max(1px,_0.0625rem)] border-solid border-[#cfa751] md:w-[90%] w-full focus:outline-none focus:ring-0 focus:border-[#cfa751] peer"
                  placeholder=""
                  required
                />
                <label
                  for="number"
                  className="peer-focus:font-semibold peer-focus:text-[1.3rem] absolute uppercase font-Matter text-[1rem] text-white tracking-[.2em] form-line-flex focus-within:[&>label]:text-[#cfa751] font-semibold duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#cfa751] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Your phone number
                </label>
              </div>
              <div data-aos="fade-up" data-aso-delay="300" className="relative z-0 w-full group xl:my-[5.135rem] md:my-16 my-8 flex flex-col-reverse">
                <input
                  type="email"
                  name="email"
                  id="email"
                  className="pt-[1.2rem] pb-[1.2rem] tracking-[0.02em] text-[1.3rem] font-Matter text-white outline-2 outline-transparent outline-offset-2  appearance-none outline-none block bg-transparent border-b-[max(1px,_0.0625rem)] border-solid border-[#cfa751] md:w-[90%] w-fullfocus:outline-none focus:ring-0 focus:border-[#cfa751] peer"
                  placeholder=""
                  required
                />
                <label
                  for="email"
                  className="peer-focus:font-semibold peer-focus:text-[1.3rem] absolute uppercase font-Matter text-[1rem] text-white tracking-[.2em] form-line-flex focus-within:[&>label]:text-[#cfa751] font-semibold duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#cfa751] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Your email
                </label>
              </div>
            </div>
            <div data-aos="fade-up" data-aso-delay="300" className="">
              <div className="mt-[2.6rem] mb-[1rem] relative my-[3.135rem] ">
                <textarea
                  placeholder="Your message"
                  id="form-input-message"
                  cols="30"
                  rows="14" required
                  className="bg-transparent mt-[.25rem] w-full rounded-[2rem] py-[1.5rem] px-[2rem] outline-none border-[max(1px,_0.0625rem)] border-solid border-[#cfa751] h-[15rem] md:h-[22.5rem] xl:h-[28.1rem] text-[1.3rem] text-white font-Matter font-semibold placeholder-white placeholder:uppercase placeholder:tracking-[.2em] placeholder:text-[1rem]"
                ></textarea>
              </div>
            </div>
          </div>

          <div className=" text-center">
            <div data-aos="fade-up" data-aso-delay="100" className="relative inline-flex flex-row justify-center items-center md:my-10 my-5 text-white font-Matter font-semibold uppercase text-[1rem] tracking-[.2em]">
              <label
                className="flex items-center cursor-pointer py-0 my-0"
                htmlFor="form-input-newsletter"
              >
                <input
                  type="checkbox" required
                  id="form-input-newsletter"
                  className="peer sr-only"
                />
                <span className="relative mr-[.75rem] h-[2rem] w-[2rem] rounded-[.375rem] border-[max(1px,_0.0625rem)] border-solid border-[#cfa751] bg-transparent flex items-center justify-center peer-checked:bg-[#cfa751] peer-checked:after:content-['✓'] peer-checked:after:text-black peer-checked:after:text-[1rem] peer-checked:after:leading-none peer-checked:after:font-bold"></span>
                <span>Subscribe to our newsletter</span>
              </label>
            </div>
            <div data-aos="fade-up" className="">
              <div className="inline-flex  bg-transparent relative h-[3.5rem] items-center rounded-[9999px] px-[2rem] text-[1.125rem] font-semibold font-Matter tracking-[-.06em] ">
                {/* <button className="bg-[#cfa751] border-[max(1px,_0.0625rem)] border-solid border-[#cfa751] py-5 px-10 rounded-[9999px] mt-10 font-semibold font-Matter tracking-[.2em] text-[1.3rem]">
                  submit
                </button> */}
                <button className="group relative inline-flex h-14 mt-6  items-center rounded-full px-16  font-semibold text-black bg-transparent overflow-hidden">
                  <span className="absolute inset-0 rounded-full bg-[#cfa751] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                    <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                      <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    </span>
                  </span>

                  <span className="relative">
                    <span className="flex flex-row gap-2 justify-center font-Matter tracking-wider items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      submit
                    </span>
                    <span className="absolute flex flec-row gap-2 top-0 font-Matter tracking-wider left-0 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                   submit
                    </span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
